//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getIsEditingPost = createSelector(
  (state: ICuralateStore) => state.instagram.postDetails.postId,
  (postId) => !!postId,
);
